import { NurseLayout } from "@/components/layout/nurse-layout";
import { DictationWorkspace } from "@/pages/shared/dictation";

export default function NurseDictation() {
  return (
    <NurseLayout title="Clinical Note Dictation">
      <DictationWorkspace
        audience="nurse"
        accentClass="bg-gradient-to-br from-teal-700 to-teal-900 text-white"
        primaryBtnClass="bg-teal-700 hover:bg-teal-800"
        title="Dictate a clinical note"
        subtitle="Speak freely — Whisper transcribes and GPT structures the draft, grounded in the NMC Code, for you to review and sign."
      />
    </NurseLayout>
  );
}
